import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_agilebot.png",
      alt: "Estratégias Agilebox",
    },
    title: "Agilebox",

    // String ou array de strings
    text: "O AGILE BOX (®) é um produto de altíssima tecnologia! Um Trader Virtual projetado pela Agile INVESTE que opera na Bolsa de Valores automaticamente para você. Desenvolvido com tecnologia de Inteligência Artificial, otimiza seu tempo e possibilita que você invista de forma assertiva e segura, sem a necessidade de conhecimentos avançados. É só assinar e acompanhar seus resultados.",
    // testimonial: {
    //   text: "",
    //   author: {
    //     name: "",
    //     picture: "",
    //   },
    // },
  },

  strategies: {
    title: "Robô Agilebox",
    heading: "Mais assertividade e eficiência em seus investimentos",
    subtitle:
      "Nosso robô foi desenvolvido utilizando inteligência artificial, com isso ele analisa diversas variáveis e se adapta às condições de mercado, de tendência ou de consolidação. Inicia sempre com um contrato e amplia o volume conforme sua avaliação.",
  },

  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão Agile.",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "A Agile INVESTE",
    col1: [
      "A Agile INVESTE nasceu para melhorar a vida das pessoas. Oferecemos capacitação, tecnologia e recomendações para quem quer investir em renda variável.",
    ],
    col2: [
      "Acreditamos que investir deve ser uma opção simples e acessível para todos. Oferecemos uma gama extensa de diferentes tipos de serviços, que se adequam ao que você busca no mercado financeiro.",
    ],
  },

  // stats: {
  //   title: "Alguns números da Benndorf",
  //   subtitle:
  //     "Da educação financeira à agilidade nas operações, o objetivo da casa de análises é auxiliar todo tipo de trader a operar mais e melhor.",
  //   data: [
  //     {
  //       value: "+7 anos",
  //       description: "Ajudando investidores e traders a alcançarem resultados.",
  //     },
  //     {
  //       value: "+700%",
  //       description:
  //         "De retornos desde 2011 com seu principal produto, a Absolute 30.",
  //     },
  //     {
  //       value: "+2 anos",
  //       description:
  //         "Fechando todos os meses (2020 até Jul/2022) no positivo em dólar e índice, com as operações do analista João Tonello.",
  //     },
  //   ],
  // },

  features: {
    title: "Por que utilizar os robôs da Agile?",
    subtitle: "Veja quais as principais vantagens dos robôs da Agile.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "7 dias para testar",
        description: "Teste o Agilebox e confira seu potencial!",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description: "Você só precisa assinar e deixar o robô investir para você.",
      },
      {
        icon: iconsSet.lock_line,
        title: "Segurança e eficiência",
        description:
          "Nosso robô irá operar na bolsa de valores apenas com o capital que você determinar em sua corretora.",
      },
      {
        icon: iconsSet.growth,
        title: "Aumento nas suas chances de sucesso",
        description:
          "Nosso robô de inteligência artificial (IA) encontra as melhores oportunidades de negociações, melhorando suas chances de sucesso.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe tempo",
        description:
          "Você não precisa ficar na frente no computador para realizar suas operações. Escolha suas estratégias e deixe que a plataforma opere por você.",
      },
      {
        icon: iconsSet.graduation_cap,
        title: "Anos de experiência no mercado",
        description:
          "Nossa empresa programa Robôs Investidores e Indicadores a muitos anos no mercado, temos clientes no mundo todo satisfeitos com nossa automação.",
      },
      // ...defaultContent.features.data,
    ],
  },

  plans: {
    title: "Planos",
    subtitle: "Conheça os planos da extensão Agile",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
